import { DebugStepType } from '@/shared/types/tryIt';

import { flattenSteps } from './steps';
import { ConversationTurn } from '../types/conversation';

export type TurnJump = { nodeId: string; name: string };

export const turnJumps = (turn: ConversationTurn): TurnJump[] => {
  const stack = turn.metadata.nodesStack ?? [];

  return flattenSteps(turn.metadata.steps)
    .filter(
      (step) =>
        step.type === DebugStepType.ACTION && step.action_type === 'event' && Boolean(step.node_id)
    )
    .map((step) => ({
      nodeId: step.node_id as string,
      name: stack.find((node) => node.node_id === step.node_id)?.name ?? (step.node_id as string),
    }));
};

export const trailJumps = (sourceName: string | undefined, jumps: TurnJump[]): TurnJump[] =>
  jumps.filter((jump, index) => jump.name !== (jumps[index - 1]?.name ?? sourceName));
